import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Tabs } from 'tdesign-react';
import CodeMirrorLight from '@/components/CodeMirrorLight';
import Tip from '@/components/Tip';
import { isValidJSON } from '@/utils/common';

/**
 * @typedef {import("./type").Props} Props
 */

// 简单校验JSON，如有值，校验是否合法
// 仅限RCField
export function isValidSubJSONRC(_, str) {
  if (!str) return Promise.resolve();
  try {
    const parent = JSON.parse(str);
    let existsSubErrorJson = false;
    if (typeof parent === 'object') {
      for (const [, subStr] of Object.entries(parent)) {
        if (!isValidJSON(subStr)) {
          existsSubErrorJson = true;
          break;
        }
      }
    }
    if (!existsSubErrorJson) return Promise.resolve();
    return Promise.reject('存在非法JSON');
  } catch (e) {
    return Promise.reject('存在非法JSON');
  }
}

/**
 * 多个JSON录入
 * @param {Props} props
 * @returns {React.FC<Props>}
 */
export default function JSONsInput({ value, onChange, tabs, ...others }) {
  const [currentTab, setCurrentTab] = useState(tabs[0].value);

  const json = useMemo(() => {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }, [value]);

  const mirrorChange = (jsonStr, key) => {
    onChange(JSON.stringify({ ...json, [key]: jsonStr }));
  };

  return (
    <Root>
      <Tabs value={currentTab} theme='card' onChange={setCurrentTab}>
        {tabs?.map((tab) => (
          <Tabs.TabPanel
            key={tab.value}
            value={tab.value}
            label={<Tip content={tab.tip}>{tab.label}</Tip>}
          >
            <CodeMirrorLight
              value={json?.[tab.value] || ''}
              onChange={(jsonStr) => mirrorChange(jsonStr, tab.value)}
              placeholder={tab.placeholder}
              type='json'
              {...others}
            />
          </Tabs.TabPanel>
        ))}
      </Tabs>
    </Root>
  );
}

const Root = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 139px;
  .t-tabs__nav {
    min-height: 0 !important;
    .t-tabs__nav-container {
      background-color: #fff;
      .t-tabs__nav--card.t-tabs__nav-item {
        background-color: #fff;
        border-left: 1px solid rgb(237, 237, 237);
        border-right: 1px solid rgb(237, 237, 237);
        border-top: 1px solid rgb(237, 237, 237);
        border-radius: 6px 6px 0px 0px;
        margin-right: 10px;
        &.t-is-active {
          background-color: #fafafa;
        }
      }
      .t-tabs__nav-item.t-size-m {
        height: var(--td-comp-size-l);
        line-height: var(--td-comp-size-l);
      }
    }
  }

  .t-tabs__content {
    position: relative;
    border: 1px solid rgba(0, 0, 0, 0.05);
    margin-top: -1px;
    z-index: 1;
    border-radius: 0px 0 6px 6px;
    background-color: #fafafa;
  }

  .cm-editor {
    min-height: 100px;
    background-color: #fafafa;
  }
`;
